import { render } from "./personal-list.vue?vue&type=template&id=dced8e70&scoped=true"
import script from "./personal-list.vue?vue&type=script&lang=js"
export * from "./personal-list.vue?vue&type=script&lang=js"

import "./personal-list.vue?vue&type=style&index=0&id=dced8e70&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dced8e70"]])

export default __exports__